<template>
    <div>
        <input-label v-if="label"
            :for_element="name"
            v-html="$t(label)"
        ></input-label>

        <div class="relative">
            <span class="absolute flex h-full items-center left-0 text-sm pl-2 top-0">
                {{ currency_symbol }}
            </span>

            <input type="text"
                class="field w-full indent"
                :class="{ 'read_only': read_only }"
                :name="name"
                :placeholder="$t(placeholder)"
                :value="value || null"
                @input="$emit('input', $event.target.value)"
                v-bind="$attrs"
                :tabindex="read_only ? -1 : 0"
                v-input-mask data-inputmask-alias="currency"
            >
        </div>
    </div>
</template>

<script>
import MoneyFunctions from '../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    inheritAttrs: false,

    props: {
        label: {},
        name: {},
        placeholder: {},
        value: { default: null },
        read_only: { default: false },
    },

    computed: {
        currency_symbol() {
            return store.state.currency_symbol || '$';
        },
    },

    created() {
        this.$emit('input', this.formatMoney(this.value));
    },
}
</script>

<style scoped>
    .read_only {
        background-color: #f7f7f7 !important;
        border-color: #f7f7f7 !important;
        color: #262626 !important;
        pointer-events: none;
    }

    .accordion .read_only {
        background-color: #fcfcfc !important;
    }

    .read_only::placeholder {
        color: transparent !important;
    }
</style>
